var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader',{attrs:{"loading":_vm.categories === null}},[_vm._t("categories",null,null,{ categories: _vm.categories })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }